import { MunicipioDTO } from './../dto/municipio-dto';
import { BaseModel } from "./base-model";

export interface IEndereco {
    Id: string;
    Cep: string;
    DescricaoEndereco: string;
    Bairro: string;
    MunicipioId: string;
    Municipio: string;
    UF: string;
}

export class Endereco extends BaseModel implements IEndereco {
    /**
     *
     */
    constructor(data: any = {}) {
        data = data || {};
        super();
        this.Id = data.Id;
        this.Cep = data.Cep;
        this.DescricaoEndereco = data.DescricaoEndereco;
        this.Bairro = data.Bairro;
        this.MunicipioSelect = data.MunicipioId && new MunicipioDTO({ Id: data.MunicipioId, Nome: data.Municipio, UF: data.UF });
        this.MunicipioId = data.MunicipioId;
        this.Municipio = data.Municipio;
        this.UF = data.UF;


    }
    Id: string;
    Cep: string;
    DescricaoEndereco: string;
    Bairro: string;
    MunicipioId: string;
    Municipio: string;
    UF: string;


    private _MunicipioSelect: MunicipioDTO;
    public get MunicipioSelect(): MunicipioDTO {
        return this._MunicipioSelect;
    }
    public set MunicipioSelect(v: MunicipioDTO) {
        this._MunicipioSelect = v;

        this.MunicipioId = v && v.Id;
        this.UF = v && v.UF;
    }

}